const config = {
    build_number: '615816',
    build_timestamp: '2026-09-03T20:41:52.480Z',
    build_commit: '23fa142b70654d6b8709e12002937e224e23ea92',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
